import { render, staticRenderFns } from "./NormalSearchNav245.vue?vue&type=template&id=0bf9ef07&scoped=true&"
import script from "./NormalSearchNav245.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav245.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf9ef07",
  null
  
)

export default component.exports